import { useState } from 'react';
import { GoogleSignUpButton } from './google/GoogleSignUpButton';
import { LinkedInSignUpButton } from './linkedin/LinkedInSignUpButton';
import { SignUpDivider } from './SignUpDivider';
import { SignUpUsingEmailButton } from './SignUpUsingEmailButton';
import { ToSCheckbox } from './ToSCheckbox';

type OauthSignUpSegmentProps = {
  isRep?: boolean;
  onSignUpWithEmailClick: () => void;
  orgInviteId?: string | null;
  corporateClientId?: string | null;
  impactPartnerId?: string | null;
};

export const OauthSignUpSegment = (props: OauthSignUpSegmentProps) => {
  const { isRep, onSignUpWithEmailClick, orgInviteId, corporateClientId, impactPartnerId } = props;
  const [isChecked, setIsChecked] = useState(false);

  const [error, setError] = useState<string>();

  const onChecked = (checked: boolean) => {
    setIsChecked(checked);
    setError(undefined);
  };

  const onClickIfToSNotConfirmed = () => {
    setError('To continue, agree to the terms of use.');
  };

  return (
    <div className='w-full flex flex-col items-center justify-center gap-6'>
      <div className={'w-full flex flex-col gap-3'}>
        <GoogleSignUpButton
          isRep={isRep}
          isToSConfirmed={isChecked}
          onClickIfToSNotConfirmed={onClickIfToSNotConfirmed}
          orgInviteId={orgInviteId}
          impactPartnerId={impactPartnerId}
          corporateClientId={corporateClientId}
        />
        <LinkedInSignUpButton
          isRep={isRep}
          isToSConfirmed={isChecked}
          onClickIfToSNotConfirmed={onClickIfToSNotConfirmed}
          orgInviteId={orgInviteId}
          impactPartnerId={impactPartnerId}
          corporateClientId={corporateClientId}
        />
      </div>
      <SignUpDivider />
      <SignUpUsingEmailButton onClick={onSignUpWithEmailClick} />
      <ToSCheckbox checked={isChecked} onChange={onChecked} error={error} />
    </div>
  );
};
